import React, { FC } from 'react';
import cls from './WeeksModePosition.module.css';
import classNames from 'classnames';

import { useSelector } from 'react-redux';

import moment from 'moment/moment';
import { PositionIItem } from '../../../../../../UI/PositionItem/PositionIItem';

export const WeekItemPosition = ({ position, week, isPlanFact }) => {
    const { settings } = useSelector((state) => state.gantReducer);

    if (!position) return null;

    const positionDate = moment(position.planned.start_date).format('DD.MM.YYYY');

    const isShowPosition = !settings.isShowMHD && position?.type !== 'labor';
    const nowDate = moment().format('DD.MM.YYYY');

    const isRenderDays = week.days.includes(positionDate) || week.days.includes(nowDate);

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!position?.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    if (isShowPosition) {
        return null;
    }

    return (
        <div className={classNames(cls.week, { [cls.factWrapper]: isPlanFact })}>
            {isRenderDays &&
                week.days.map((day) => (
                    <div
                        key={day + Math.random().toString(36)}
                        className={classNames(cls.day, {
                            [cls.factWrapper]: isPlanFact,
                            [cls.nowDate]: day === nowDate,
                        })}
                        data-id={day}
                    >
                        {positionDate === day && (
                            <PositionIItem isPlanFact={isPlanFact} position={position} />
                        )}
                    </div>
                ))}
        </div>
    );
};
